// extracted by mini-css-extract-plugin
module.exports = {"base":"autoupdater_base__3CH5w","spinner":"autoupdater_spinner__3ULnt"};